import * as Types from '../../../types/generated';

import { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetSimilarCandidatesSeekOrCombinedQueryVariables = Types.Exact<{
  email: Types.Scalars['String']['input'];
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  isSeedProfileLocationOnly?: Types.InputMaybe<
    Types.Scalars['Boolean']['input']
  >;
  countryCode: Types.Scalars['String']['input'];
  profileTypes?: Types.InputMaybe<
    Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input']
  >;
  language?: Types.InputMaybe<Types.Scalars['LanguageCodeIso']['input']>;
}>;

export type GetSimilarCandidatesSeekOrCombinedQuery = {
  seekOrCombinedProfiles:
    | { __typename: 'ResponseError'; error: Types.ResponseErrorReason }
    | { __typename: 'SimilarCandidatesNoSimilarProfilesSuccessResponse' }
    | {
        __typename: 'SimilarCandidatesSuccessResponse';
        result: {
          totalCount: number;
          seedProfile?: {
            profileGuid?: string | null;
            profileType: Types.ProfileTypes;
          } | null;
          edges: Array<{
            node: {
              profileGuid?: string | null;
              firstName: string;
              lastName: string;
              currentLocation?: string | null;
              pastJobTitles?: Array<string> | null;
              profileType: Types.ProfileTypes;
              currentJobTitle?: string | null;
              lastModifiedDate?: string | null;
              salary?: {
                expected?: {
                  currency: string;
                  amount: Array<{
                    frequency: Types.SalaryFrequency;
                    value: any;
                  }>;
                } | null;
              } | null;
              workHistories: Array<{
                companyName: string;
                endDate?: string | null;
                startDate?: string | null;
              }>;
            };
          }>;
        };
      };
};

export const GetSimilarCandidatesSeekOrCombinedDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetSimilarCandidatesSeekOrCombined' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'email' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'first' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'isSeedProfileLocationOnly' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'countryCode' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'profileTypes' },
          },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'String' },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'language' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'LanguageCodeIso' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'seekOrCombinedProfiles' },
            name: { kind: 'Name', value: 'similarCandidatesV2' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'byEmail' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'email' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'email' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'first' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'first' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: {
                              kind: 'Name',
                              value: 'isSeedProfileLocationOnly',
                            },
                            value: {
                              kind: 'Variable',
                              name: {
                                kind: 'Name',
                                value: 'isSeedProfileLocationOnly',
                              },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'countryCode' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'countryCode' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'profileTypes' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'profileTypes' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'SimilarCandidatesSuccessResponse',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'result' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'seedProfile' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'FragmentSpread',
                                    name: {
                                      kind: 'Name',
                                      value: 'SeedProfileFields',
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'totalCount' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'edges' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'node' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'InlineFragment',
                                          typeCondition: {
                                            kind: 'NamedType',
                                            name: {
                                              kind: 'Name',
                                              value:
                                                'TalentSearchProfileResultV2',
                                            },
                                          },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'FragmentSpread',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'ProfileFields',
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value:
                        'SimilarCandidatesNoSimilarProfilesSuccessResponse',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: '__typename' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ResponseError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'error' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SeedProfileFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TalentSearchProfileResultV2' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'profileGuid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'profileType' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ProfileFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TalentSearchProfileResultV2' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'profileGuid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'currentLocation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'language' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'language' },
                },
              },
            ],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'pastJobTitles' } },
          { kind: 'Field', name: { kind: 'Name', value: 'profileType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentJobTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastModifiedDate' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'salary' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'expected' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'frequency' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'value' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'currency' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'workHistories' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetSimilarCandidatesSeekOrCombinedQuery__
 *
 * To run a query within a React component, call `useGetSimilarCandidatesSeekOrCombinedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSimilarCandidatesSeekOrCombinedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSimilarCandidatesSeekOrCombinedQuery({
 *   variables: {
 *      email: // value for 'email'
 *      first: // value for 'first'
 *      isSeedProfileLocationOnly: // value for 'isSeedProfileLocationOnly'
 *      countryCode: // value for 'countryCode'
 *      profileTypes: // value for 'profileTypes'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useGetSimilarCandidatesSeekOrCombinedQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetSimilarCandidatesSeekOrCombinedQuery,
    GetSimilarCandidatesSeekOrCombinedQueryVariables
  > &
    (
      | {
          variables: GetSimilarCandidatesSeekOrCombinedQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetSimilarCandidatesSeekOrCombinedQuery,
    GetSimilarCandidatesSeekOrCombinedQueryVariables
  >(GetSimilarCandidatesSeekOrCombinedDocument, options);
}
export function useGetSimilarCandidatesSeekOrCombinedLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSimilarCandidatesSeekOrCombinedQuery,
    GetSimilarCandidatesSeekOrCombinedQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetSimilarCandidatesSeekOrCombinedQuery,
    GetSimilarCandidatesSeekOrCombinedQueryVariables
  >(GetSimilarCandidatesSeekOrCombinedDocument, options);
}
export function useGetSimilarCandidatesSeekOrCombinedSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetSimilarCandidatesSeekOrCombinedQuery,
        GetSimilarCandidatesSeekOrCombinedQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetSimilarCandidatesSeekOrCombinedQuery,
    GetSimilarCandidatesSeekOrCombinedQueryVariables
  >(GetSimilarCandidatesSeekOrCombinedDocument, options);
}
export type GetSimilarCandidatesSeekOrCombinedQueryHookResult = ReturnType<
  typeof useGetSimilarCandidatesSeekOrCombinedQuery
>;
export type GetSimilarCandidatesSeekOrCombinedLazyQueryHookResult = ReturnType<
  typeof useGetSimilarCandidatesSeekOrCombinedLazyQuery
>;
export type GetSimilarCandidatesSeekOrCombinedSuspenseQueryHookResult =
  ReturnType<typeof useGetSimilarCandidatesSeekOrCombinedSuspenseQuery>;
export type GetSimilarCandidatesSeekOrCombinedQueryResult = Apollo.QueryResult<
  GetSimilarCandidatesSeekOrCombinedQuery,
  GetSimilarCandidatesSeekOrCombinedQueryVariables
>;
